import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-20 pb-6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/5e7893d9-3df1-4ab0-9579-21994c142bf0.png" 
              alt="918Turf" 
              className="h-16 mb-6 transition-opacity duration-200 hover:opacity-80"
            />
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Tulsa's premier synthetic turf distributor. Premium quality, wholesale pricing, local service.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-green-500 hover:text-green-500 transition-all duration-200 cursor-pointer hover:shadow-md" style={{ transform: 'translateY(0)' }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-green-500 hover:text-green-500 transition-all duration-200 cursor-pointer hover:shadow-md" style={{ transform: 'translateY(0)' }} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">Quick Links</h4>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">About Us</Link></li>
              <li><Link to="/landscape-turf" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Landscape Turf</Link></li>
              <li><Link to="/pet-turf" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Pet Turf</Link></li>
              <li><Link to="/athletic-turf" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Athletic Turf</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">Products</h4>
            <ul className="space-y-4">
              <li><Link to="/putting-green-turf" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Putting Greens</Link></li>
              <li><Link to="/landscape-turf" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Installation Supplies</Link></li>
              <li><a href="tel:918-806-8873" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Wholesale Pricing</a></li>
              <li><a href="tel:918-806-8873" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">Request Quote</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:918-806-8873" className="text-xl font-semibold text-white hover:text-green-400 transition-colors duration-150 cursor-pointer flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  918-806-8873
                </a>
              </li>
              <li>
                <a href="mailto:info@918turf.com" className="text-base text-white hover:text-green-400 transition-colors duration-150 cursor-pointer">info@918turf.com</a>
              </li>
              <li className="text-sm text-gray-400 leading-relaxed">
                Serving Tulsa, OK<br />and surrounding areas
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 pb-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">© 2025 918Turf.com. All rights reserved.</p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-green-400 transition-colors duration-150 cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
